<template>
  <div class="page">
    <a-table
      class="sec"
      size="small"
      :rowKey="(record) => record.id"
      bordered
      :columns="columns"
      :data-source="list"
      :pagination="false"
    >
      <template slot="status" slot-scope="text, record">
        <a-tag v-if="record.status == 1" color="green">已开启</a-tag>
        <a-tag v-else color="red">已关闭</a-tag>
      </template>

      <template slot="goods" slot-scope="text, record">
        <router-link :to="'/auction/goods/list?auc_id=' + record.id">拍品列表</router-link>
      </template>

      <template slot="order_list" slot-scope="text, record">
        <router-link :to="'/auction/order/list?auc_id=' + record.id">订单列表</router-link>
      </template>

      <template slot="action" slot-scope="text, record">
        <router-link :to="'/auction/info?id=' + record.id">详情</router-link>
        <a-divider type="vertical" />
        <router-link :to="'/auction/update?id=' + record.id">编辑</router-link>
        <a-divider type="vertical" />
        <a-popconfirm
          :title="record.status == 1 ? '确定要关闭吗？' : '确定要开启吗？'"
          ok-text="确定"
          cancel-text="取消"
          @confirm="updateStatus(record.id, (record.status + 1) % 2)"
        >
          <a href="javascript:;">{{record.status == 1 ? '关闭' : '开启'}}</a>
        </a-popconfirm>
      </template>
    </a-table>

    <a-pagination
      class="pagination"
      showQuickJumper
      v-model="page.now_page"
      :defaultPageSize="page.page_size"
      :total="page.amount"
      @change="changePage"
    />
  </div>
</template>

<style lang='scss' scoped>
</style>

<script>
const columns = [
  {
    title: "#",
    dataIndex: "id",
  },
  {
    title: "场次",
    dataIndex: "title",
  },
  {
    title: "开始时间",
    dataIndex: "start_at",
  },
  {
    title: "结束时间",
    dataIndex: "end_at",
  },
  {
    title: "备注",
    dataIndex: "desc",
  },
  {
    title: "状态",
    scopedSlots: {
      customRender: "status",
    },
  },
  {
    title: "拍品",
    scopedSlots: {
      customRender: "goods",
    },
  },
  {
    title: "订单",
    scopedSlots: {
      customRender: "order_list",
    },
  },
  {
    title: "操作",
    scopedSlots: {
      customRender: "action",
    },
  },
];

export default {
  data() {
    return {
      columns,
      list: [],
      page: {
        now_page: 1,
        page_size: 50,
        amount: 0,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    changePage(e) {
      this.page.now_page = e;
      this.getList();
    },

    async getList() {
      const page = this.page.now_page;
      const r = await this.$axios.get("/auction/getList", {
        params: {
          page,
        },
      });

      if (r.status != 1) return;

      this.list = r.list;
      this.page.amount = r.amount;
    },

    async updateStatus(id, status) {
      const r = await this.$axios.post("/auction/updateStatus", {
        id,
        status,
      });

      if (r.status == 1) this.getList();
    },
  },
};
</script>